module.exports = __webpack_public_path__ + "media/organizations/Ebay-33285aa2.webp";